import React from 'react'
import PropTypes from 'prop-types'
import MuiRadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Radio } from '../Radio'
import {
  GroupWrapper,
  RadioOption,
  RadioContent,
  RadioLabel,
  RadioDescription,
} from './styles'

export const RadioGroup = ({ options, value, onChange, name }) => {
  if (!options || options.length === 0) return null

  return (
    <MuiRadioGroup
      name={name}
      value={value}
      onChange={(event) => onChange && onChange(event.target.value)}
    >
      <GroupWrapper>
        {options.map((option, index) => {
          const selected = value === option.value
          return (
            <RadioOption
              key={`radio-${index}`}
              $selected={selected}
              $disabled={option.disabled}
            >
              <FormControlLabel
                value={option.value}
                disabled={option.disabled}
                control={<Radio />}
                label={
                  <RadioContent>
                    <RadioLabel>{option.label}</RadioLabel>
                    {option.description && (
                      <RadioDescription>{option.description}</RadioDescription>
                    )}
                  </RadioContent>
                }
                sx={{ margin: 0, alignItems: 'flex-start', width: '100%' }}
              />
            </RadioOption>
          )
        })}
      </GroupWrapper>
    </MuiRadioGroup>
  )
}

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  name: PropTypes.string,
}

RadioGroup.defaultProps = {
  options: [],
  name: 'radio-group',
}
